import { MarketType } from '@mg-platform/reports/reports-data-access'

export interface IDashboardGrossProfitItem {
  id: string
  displayText: string
  value: number
  valueFormatted: string
  marketType: MarketType
}

export interface IDashboardGrossProfitResponse {
  intervalLabel: string
  items: IDashboardGrossProfitItem[]
}
